import AsyncStorage from 'shared/asyncStorage';
import ApiUtils from 'shared/ApiUtils';

export const ACCESS_TOKEN = 'accessToken';

export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';

export const REGISTER_START = 'REGISTER_START';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';

export const LOGOUT_START = 'LOGOUT_START';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const CLEAR_AUTH_ERRORS = 'CLEAR_AUTH_ERRORS';
export const NO_AUTH_TOKEN = 'NO_AUTH_TOKEN';

export function loginStart() {
    return { type: LOGIN_START, receivedAt: Date.now() };
}

export function loginSuccess(user) {
    return { type: LOGIN_SUCCESS, payload: user, receivedAt: Date.now() };
}

export function loginFail(error) {
    return { type: LOGIN_FAIL, error, receivedAt: Date.now() };
}

export function logoutStart() {
    return { type: LOGOUT_START, receivedAt: Date.now() };
}

export function logoutSuccess() {
    return { type: LOGOUT_SUCCESS, receivedAt: Date.now() };
}

export function registerStart() {
    return { type: REGISTER_START, receivedAt: Date.now() };
}

export function registerSuccess() {
    return { type: REGISTER_SUCCESS, receivedAt: Date.now() };
}

export function registerFail(error) {
    return { type: REGISTER_FAIL, error, receivedAt: Date.now() };
}

export function clearAuthErrors() {
    return { type: CLEAR_AUTH_ERRORS, receivedAt: Date.now() };
}

export function noAuthToken() {
    return { type: NO_AUTH_TOKEN, receivedAt: Date.now() };
}

export const checkAuth = () => dispatch => {
    return AsyncStorage.getItem(ACCESS_TOKEN)
        .then(token => {
            if (token) {
                dispatch(userLoginViaToken(token))
            } else {
                dispatch(noAuthToken())
            }
        })
}

export const userLogin = (email, password) => dispatch => {
    dispatch(loginStart())
    const url = 'https://houseatl.cloud.rnoc.gatech.edu/rest/rpc/login';
    // console.log(email);
    return ApiUtils.post(url, { email, password })
        .then(([response, jsonBody]) => {
            if (response.status === 200) {
                const { me, token } = jsonBody[0]
                AsyncStorage.setItem(ACCESS_TOKEN, token).catch(err => {
                    console.log('AsyncStorage error: ' + err.message);
                });
                dispatch(loginSuccess(me));
            } else {
                dispatch(loginFail(jsonBody.message));
            }
        }).catch(err => {
            dispatch(loginFail(err.message));
        });
}

export const userLoginViaToken = (token) => dispatch => {
    dispatch(loginStart())
    const url = 'https://houseatl.cloud.rnoc.gatech.edu/rest/rpc/me';
    return ApiUtils.getAuth(url, token)
        .then(([response, jsonBody]) => {
            if (response.status === 200) {
                dispatch(loginSuccess(jsonBody[0]));
            } else {
                dispatch(loginFail(jsonBody.message));
            }
        }).catch(err => {
            dispatch(loginFail(err.message));
        });
}

export const userLogout = () => dispatch => {
    dispatch(logoutStart())
    AsyncStorage.removeItem(ACCESS_TOKEN)
        .then(() => {
            dispatch(logoutSuccess());
        }).catch(err => {
            console.log('AsyncStorage error: ' + err.message);
        });
}

export const userRegister = (obj) => dispatch => {
    dispatch(registerStart())
    const url = 'https://houseatl.cloud.rnoc.gatech.edu/rest/rpc/signup';
    return ApiUtils.post(url, obj)
        .then(([response, jsonBody]) => {
            if (response.status === 200) {
                dispatch(registerSuccess());
            } else {
                dispatch(registerFail(jsonBody.message));
            }
        }).catch(err => {
            dispatch(registerFail(err.message));
        });
}